import React, { useState } from 'react';
import dataStore from '../utils/dataStore';

const SubscribeForm = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) return;
    const result = dataStore.addSubscriber(email);
    setStatus(result.success ? 'success' : 'duplicate');
    if (result.success) setEmail('');
    setTimeout(() => setStatus(''), 4000);
  };

  return (
    <div className="subscribe-section">
      <h2>Stay in the Loop</h2>
      <p>Get notified when new articles and projects drop. No spam, just engineering gold.</p>
      <form className="subscribe-form" onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="your@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit">Subscribe</button>
      </form>
      {status === 'success' && (
        <p className="subscribe-success">Welcome aboard! You're subscribed.</p>
      )}
      {status === 'duplicate' && (
        <p className="subscribe-success" style={{ color: 'var(--accent-warm)' }}>
          You're already subscribed!
        </p>
      )}
    </div>
  );
};

export default SubscribeForm;
